// extracted by mini-css-extract-plugin
module.exports = {"linkedInIconContainer":"LinkedIn_linkedInIconContainer__12hG7","linkedInIcon":"LinkedIn_linkedInIcon__1drP-"};